<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">
            Edit User
          </h4>
        </div>

        <!-- Popup content -->
        <div class="modal-body row" v-if="user != null">
          <!-- Form -->

          <!-- First Name -->
          <div
            class="form-group col-xs-12 col-sm-6"
            v-bind:class="{ 'has-error': $v.user.firstName.$error }"
          >
            <label>First name</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter first name"
              v-model="user.firstName"
              @input="$v.user.firstName.$touch()"
              >
            <span class="help-block" v-if="!$v.user.firstName.required && $v.user.firstName.$error">First name is required</span>
          </div>

          <!-- Last Name -->
          <div
            class="form-group col-xs-12 col-sm-6"
            v-bind:class="{ 'has-error': $v.user.lastName.$error }"
          >
            <label>Last name</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter last name"
              v-model="user.lastName"
              @input="$v.user.lastName.$touch()"
            >
            <span
              class="help-block"
              v-if="!$v.user.lastName.required && $v.user.lastName.$error"
            >
              Last name is required
            </span>
          </div>

          <!-- Email -->
          <div
            class="form-group col-xs-12 col-sm-6"
            v-bind:class="{ 'has-error': $v.user.email.$error }"
          >
            <label>Email</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter email"
              v-model="user.email"
              @input="$v.user.email.$touch()"
              @keydown.space.prevent 
              @paste="preventPasteSpaces"
            >
            <span
              class="help-block"
              v-if="!$v.user.email.required && $v.user.email.$error"
            >
              Email is required
            </span>
          </div>
          <div
            class="form-group col-xs-12 col-sm-6"
            v-if="user.role === userRoles.ACCOUNT_MANAGER"
          >
            <label>Account Admins</label>
            <v-select
              solo
              multiple
              dense
              :items="accountAdmins"
              v-model="user.accountAdmins"
              label="Select Admin Users"
              item-value="id"
              item-text="name"
            ></v-select>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">Close</button>
          <button type="button" class="btn btn-primary" @click="editUser">Save changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userAPIs from './userAPIs'
import config from '@/config'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'EditUserModal',
  props: [
    'modalId',
    'userData'
  ],
  data () {
    return {
      userRoles: config.userRoles,
      user: null
    }
  },
  watch: {
    userData: function (newUserData) {
      this.user = newUserData
    }
  },
  validations: {
    user: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required
      }
    }
  },
  async mounted () {
    this.accountAdmins = await this.getAdminUsers()
  },
  methods: {
    editUser: function () {
      if (this.user.email) {
        this.user.email = this.user.email.trim()
      }
      let editingUser = {
        id: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email
      }
      if (this.user.role === config.userRoles.ACCOUNT_MANAGER) {
        if (!this.user.accountAdmins.length) {
          this.$swal({
            text: 'Please select Account Admin',
            type: 'info'
          });
          return
        }
        editingUser.accountAdmins = this.user.accountAdmins
      }

      // Edit User
      userAPIs.editUser(editingUser)
        .then(response => {
          // Return the newly added data to parent component
          this.$emit('editUser', response)

          // Dismiss modal by triggering the click event on Close button
          this.$refs.closeButton.click()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    async getAdminUsers() {
      let adminUsers = await userAPIs.getAllUsersByRole(config.userRoles.COMPANY_ADMIN_HIGH)
      if (adminUsers.users) {
        adminUsers = adminUsers.users
        adminUsers = adminUsers.map(user => {
          return {
            id: user.id,
            name: `${user.firstName} ${user.lastName}`
          }
        })
        return adminUsers
      }
      return []
    },
    clearData: function () {
      this.user = {
        firstName: '',
        lastName: '',
        email: '',
        accountAdmins: []
      }
    },
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// EditUserModal.vue?3533c24e